import React from 'react';
import { MAP_CARDS_PORTAL_ID } from '@shared/components/JoyInteractableMap';
import { pxToRem } from '@withjoy/joykit/theme';
import { MapPinWithMarker } from '@shared/components/JoyInteractableMap/MapPin';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

interface MapVenueMarkerProps {
  eventPhoto?: string;
  location: google.maps.LatLngLiteral;
  forceUpdate?: string;
  pinSize?: 'sm' | 'md';
}

export const MapVenueMarker = (props: MapVenueMarkerProps) => {
  const { location, forceUpdate, pinSize, eventPhoto } = props;
  const isMobileOrTablet = useIsMobileOrTablet();
  return (
    <MapPinWithMarker
      portalContainer={document.getElementById(MAP_CARDS_PORTAL_ID) as HTMLElement}
      cardStyleOverride={{
        ...(isMobileOrTablet && {
          bottom: 52,
        }),
        width: pxToRem(280),
        height: 'auto',
        padding: pxToRem(14),
        borderRadius: pxToRem(14),
        gap: pxToRem(14),
        flexDirection: 'column',
      }}
      position={{ lat: location.lat, lng: location.lng }}
      isActive={false}
      showOnTop={true}
      isCardVisible={false}
      onDoubleClick={e => {
        e.stopPropagation();
      }}
      forceUpdate={forceUpdate || isMobileOrTablet.toString()}
      eventPhoto={eventPhoto}
      pinSize={pinSize}
    />
  );
};
